import { useEffect, useState } from "react";

const CHARS = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789#$%&@!?";

export default function DecodingKey({ value, tid, className = "" }) {
  const [display, setDisplay] = useState(value);

  useEffect(() => {
    if (!value) return undefined;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) {
      setDisplay(value);
      return undefined;
    }
    let frame = 0;
    const total = 22;
    const id = setInterval(() => {
      frame += 1;
      const reveal = Math.floor((frame / total) * value.length);
      setDisplay(value.split("").map((ch, i) => {
        if (i < reveal || ch === " " || ch === "-") return ch;
        return CHARS[Math.floor(Math.random() * CHARS.length)];
      }).join(""));
      if (frame >= total) {
        clearInterval(id);
        setDisplay(value);
      }
    }, 28);
    return () => clearInterval(id);
  }, [value]);

  return (
    <code data-testid={tid} className={`decoding-key ${className}`}>
      {display}
    </code>
  );
}
